import { loadable } from '../../../utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Item = loadable(() => import('./Item'), {});
